<template>
    <div class="cta-image-area cta-image-bg_02">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image">
                        <div class="row align-items-center">
                            <div class="col-lg-6 order-2 order-lg-1">

                                    <h4 class="cta-image__title text-white mb-20 wow move-up">How Codeperf helps, in 3
                                        easy steps</h4>

                                    <div class="requirements-list">

                                        <ul class="circle-list  text-white  green-circle-list wow move-up">
                                            <li class="list-item">Automated Github Actions Integration.</li>
                                            <li class="list-item">Zero-Touch performance and profiling reporting and
                                                comparison.</li>
                                            <li class="list-item">CI/CD workflow integration with Pull Request Comments,
                                                Notifications, and Badgees.</li>
                                        </ul>
                                        
                                        
                        <div class="slider-button mt-30">
                            <a href="#start" class="scroll btn btn--green">Get started</a>
                        </div>
                                    

                                </div>
                            </div>
                            <div class="col-lg-6 order-1 order-lg-2">
                                <div class="cta-image_two wow move-up">
                                    <img src="../assets/img/banners/magic-3-step.png" class="img-fluid"
                                        alt="aeroland-macbook-01">
                                </div>
                            </div>

                            
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CtaPullRequest',
}
</script>